import { createContext, useContext } from 'react';
import { Filter } from 'components/molecules/filters/types';
import { ProjectTargets, Frequency } from 'data/templates/status-updates/type';

interface StatusUpdatesTemplatesContext {
  templateId: number;
  templateName?: string;
  editorContent: string;
  isPublished: boolean;
  isPrivate: boolean;
  projectTarget: ProjectTargets;
  projectFilter: Filter;
  frequency: Frequency;
  serverPublishedTime: string | null;
  setServerPublishedTime: (val: string | null) => void;
  setEditorContent: (val: string) => void;
  setTemplateName: (val: string) => void;
  setPublished: (val: boolean) => void;
  setPrivate: (val: boolean) => void;
  onProjectTargetChange: (val: ProjectTargets) => void;
  setProjectFilter: (val: Filter) => void;
  updateFrequency: (val: Frequency) => void;
}

export const StatusUpdatesTemplatesContext =
  createContext<StatusUpdatesTemplatesContext | null>(null);

export const useStatusUpdatesTemplatesContext = () => {
  const context = useContext(StatusUpdatesTemplatesContext);

  if (!context) {
    throw new Error(
      'This context hook must be used within a <StatusUpdatesTemplatesContext.Provider>.',
    );
  }

  return context;
};
